import {Directive, Input, OnDestroy, TemplateRef, ViewContainerRef} from '@angular/core';
import {UtilisateurCourantService} from '../../../services/utilisateurs/utilisateur-courant.service';
import {IfAuthorizedAbstractDirective} from './if-authorized-abstract.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ifAuthorizedSuppression]',
})
export class IfAuthorizedSuppressionDirective extends IfAuthorizedAbstractDirective implements OnDestroy {
  constructor(
    viewContainerRef: ViewContainerRef,
    templateRef: TemplateRef<any>,
    utilisateurCourantService: UtilisateurCourantService,
  ) {
    super(viewContainerRef, templateRef, utilisateurCourantService);
    this.forSuppression();
  }

  @Input('ifAuthorizedSuppressionElse') set ifAuthorizedSuppressionElse(value: TemplateRef<any>) {
    this.elseTemplate = value;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  @Input() set ifAuthorizedSuppression(value: string | number) {
    this.fonctionLogicielle = value;
  }
}
